import React from 'react'
import './scheduling-tab.css'
import axios from 'axios'
import { baseUrl } from '../../../assets/Animations'
import TeacherDriveTimeBubble from '../../../AdminWorkflows/TempTeacherDistancePopup/TeacherDriveTimeBubble/TeacherDriveTimeBubble'
import { getRequestHeaders } from '../../../api'
import { isValid, parse } from 'date-fns'
import { MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank, MdCheck } from 'react-icons/md'
import { createEllipses } from '../../../utilityFunctions'

const time = ['Morning', 'Afternoon', 'Evening']

const SchedulingTab = ({modalInfo, familyInfo, setSchedulingHelperTeacherId, teacherDistanceSuggestions, setTeacherDistanceSuggestions}) => {
    const [loadingDistances, setLoadingDistances] = React.useState(false)
    const [teacherInvitations, setTeacherInvitations] = React.useState([])
    const [moreMessage, setMoreMessage] = React.useState(false)


    React.useEffect(() => {
        if(modalInfo && teacherDistanceSuggestions.length === 0) {
            getTeacherDistanceSuggestions(modalInfo.familyId, modalInfo.whichSchool, modalInfo.todoId)
            getTeacherInvitations(modalInfo.familyId)
        } else {
            setTeacherDistanceSuggestions([])
        }
    }, [])

    React.useEffect(() => {
        console.log(teacherDistanceSuggestions)
    }, [teacherDistanceSuggestions])

    React.useEffect(() => {
        if(document.getElementById('scheduling-tab-fall-2023__message-wrapper')) {
            document.getElementById('scheduling-tab-fall-2023__message-wrapper').style.height = moreMessage ? 'auto' : '60px'
        }
    }, [moreMessage])

    const removeAllDistancesOver1HourAway = (suggestions) => {
        const filteredSuggestions = suggestions.filter(suggestion => suggestion.sortingDuration < 60)
        return filteredSuggestions
    }

    const getTeacherInvitations = (familyId) => {
        axios.get(`${baseUrl}/teacher-invitations/${familyId}`, getRequestHeaders())
        .then(res => {
            setTeacherInvitations(res.data)
        })
        .catch(err => console.log(err))
    }

    const getTeacherDistanceSuggestions = (familyId, school, todoId) => {
            setLoadingDistances(true)
            axios.get(`${baseUrl}/geolocation/${familyId}/${school.toLowerCase()}/`)
            .then(res => {
                setLoadingDistances(false)
                let lessThan1HourSuggestions = removeAllDistancesOver1HourAway(res.data)
                setTeacherDistanceSuggestions(lessThan1HourSuggestions)
            })
            .catch(err => console.log(err))
    }

    const checkInitialAvailability = (avail) => {
        if (avail && avail['Monday'] && avail['Tuesday'] && avail['Wednesday'] && avail['Thursday'] && avail['Friday'] && avail['Saturday'] && avail['Sunday']) {
            if (avail['Monday'].length === 0 && avail['Tuesday'].length === 0 && avail['Wednesday'].length === 0 && avail['Thursday'].length === 0 && avail['Friday'].length === 0 && avail['Saturday'].length === 0 && avail['Sunday'].length === 0) {
                return false;
            }
            return true;
        }
        return false;
    }

    const isValidDate = (dateString, formatString) => {
        const parsedDate = parse(dateString, formatString, new Date());
        return isValid(parsedDate);
      };

    return (
        <div className='scheduling-tab-fall-2023__wrapper'>
            {checkInitialAvailability(familyInfo.initialAvailability) && 
            <div className='scheduling-tab-fall-2023__availability-wrapper-flex'>
                <div className='scheduling-tab-fall-2023__suggestions-label'>AVAILABILITY</div>
                {familyInfo.initialAvailability &&
                    <div className='scheduling-tab-fall-2023__availability-wrapper'>
                        <div className='scheduling-tab-fall-2023__time-of-day-column-labels'>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Morning</div>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Afternoon</div>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Evening</div>
                        </div>
                        {Object.keys(familyInfo.initialAvailability).map((day, index) => (
                            (familyInfo.initialAvailability[day]['Morning'] || familyInfo.initialAvailability[day]['Afternoon'] || familyInfo.initialAvailability[day]['Evening']) &&
                            <div className='scheduling-tab-fall-2023__day-wrapper' key={index}>
                                <div className='scheduling-tab-fall-2023__day-label'>{day.slice(0, 3)}</div>
                                <div className='scheduling-tab-fall-2023__time-wrapper'>
                                    {time.map((timeOfDay, index) => (
                                        <div className='scheduling-tab-fall-2023__time-label' key={index}>
                                           {familyInfo.initialAvailability[day][timeOfDay] === true ? 
                                           <div className='scheduling-tab-fall-2023__check-box' style={{border: '1px solid #14B8A6', backgroundColor: '#CCFBF1'}}>
                                               <MdCheck size={20} fill='#14B8A6' /> 
                                           </div>: 
                                           <div className='scheduling-tab-fall-2023__check-box'></div>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>}
            {familyInfo.initialAvailabilityNotes &&
                <div className='scheduling-tab-fall-2023__availability-notes-wrapper-flex'>
                    <div className='scheduling-tab-fall-2023__suggestions-label'>Message</div>
                    {
                    !isValidDate(familyInfo.initialAvailabilityNotes, 'yyyy-MM-dd') ? 
                    <div id='scheduling-tab-fall-2023__message-wrapper' className='scheduling-tab-fall-2023__message-wrapper'>
                        {familyInfo.initialAvailabilityNotes && familyInfo.initialAvailabilityNotes.length > 2 ? (moreMessage ? familyInfo.initialAvailabilityNotes : createEllipses(familyInfo.initialAvailabilityNotes, 85)) : 'No message'}
                    </div>
                    : 
                    <div style={{fontStyle: 'italic', color: 'gray'}} className='scheduling-tab-fall-2023__message-wrapper'>
                        An admin has changed family's availability. See initial email for family's original message.
                    </div>
                    }
                    <div className='scheduling-tab-fall-2023__show-more-message' onClick={() => setMoreMessage(!moreMessage)}>Show {moreMessage ? 'less' : 'more'}</div>
                </div>
            }
            {loadingDistances ? 
            <div className='scheduling-tab-fall-2023__loading-wrapper'>
                <div className='scheduling-tab-fall-2023__loading-text'>Loading...</div>
            </div>
            :
            <div className='scheduling-tab-fall-2023__suggestions-wrapper'>
                <div className='scheduling-tab-fall-2023__suggestions-label'>SUGGESTIONS</div>
                {teacherDistanceSuggestions.length === 0 && <div className='scheduling-tab-fall-2023__no-suggestions-text'>No teachers available for that instrument 😓</div>}
                <div className='scheduling-tab-fall-2023__suggestions-scroll-wrapper'>
                    {teacherDistanceSuggestions.map((suggestion, index) => (
                        <TeacherDriveTimeBubble key={index} suggestion={suggestion} invitations={teacherInvitations} setSchedulingHelperTeacherId={setSchedulingHelperTeacherId} /> 
                    ))}
                </div>
            </div>
            }
        </div>
    )
}
export default SchedulingTab